window.addEventListener('load', function() {
  const lazyDefault = new LazyLoad({
    elements_selector: '.jsLazy'
  });
});